import { apiSlice } from '../api/apiSlice';
import type {
  BridgePayerResponse,
  BridgeProviderResponse,
  BridgeServiceTypeResponse,
  ProviderEligibilityRequest,
  ProviderEligibilityResponse,
  ProviderEnrollmentStatus
} from './bridge.types';

// Bridge API calls are proxied through our backend to avoid exposing the API key.
// Consolidated into the shared apiSlice so all requests inherit the full
// authenticated prepareHeaders (Authorization + idToken + API-KEY + Platform).
//
// Previously bridgeApi was a standalone createApi with a minimal prepareHeaders
// that only attached Authorization. That caused the backend auth middleware to
// reject requests with 401 "Enter a valid API Key" because api-key was missing.
export const bridgeApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    checkProviderEligibility: build.mutation<
      ProviderEligibilityResponse,
      ProviderEligibilityRequest
    >({
      query: (body) => ({
        body,
        method: 'POST',
        url: '/bridge/provider-eligibility'
      })
    }),
    getBridgePayers: build.query<BridgePayerResponse, void>({
      query: () => '/bridge/payers'
    }),
    getBridgeProviders: build.query<BridgeProviderResponse, void>({
      query: () => '/bridge/providers'
    }),
    getProviderEnrollmentStatus: build.query<ProviderEnrollmentStatus, string>({
      query: (providerId) => `/bridge/providers/${providerId}/enrollment-status`
    }),
    getServiceTypes: build.query<BridgeServiceTypeResponse, void>({
      query: () => '/bridge/service-types'
    })
  })
});

export const {
  useCheckProviderEligibilityMutation,
  useGetBridgePayersQuery,
  useGetBridgeProvidersQuery,
  useGetProviderEnrollmentStatusQuery,
  useGetServiceTypesQuery,
  useLazyGetBridgePayersQuery,
  useLazyGetBridgeProvidersQuery,
  useLazyGetProviderEnrollmentStatusQuery
} = bridgeApi;
